var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCents = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 3.63505C10.9626 3.63505 3.63636 10.9587 3.63636 19.9928C3.63636 29.0269 10.9626 36.3505 20 36.3505C29.0374 36.3505 36.3636 29.0269 36.3636 19.9928C36.3636 10.9587 29.0374 3.63505 20 3.63505ZM0 19.9928C0 8.95108 8.9543 0 20 0C31.0457 0 40 8.95108 40 19.9928C40 31.0345 31.0457 39.9856 20 39.9856C8.9543 39.9856 0 31.0345 0 19.9928Z",
    fill: "#F98979"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9092 20.1676C10.9092 15.7015 14.9412 12.0811 19.915 12.0811H21.3891C24.5694 12.0811 27.4768 13.6945 28.899 16.2487L25.6466 17.7089C24.8403 16.2609 23.192 15.3462 21.3891 15.3462H19.915C16.9495 15.3462 14.5455 17.5048 14.5455 20.1676V20.3204C14.5455 22.9832 16.9495 25.1417 19.915 25.1417H21.3891C23.192 25.1417 24.8403 24.2271 25.6466 22.779L28.899 24.2393C27.4768 26.7935 24.5694 28.4069 21.3891 28.4069H19.915C14.9412 28.4069 10.9092 24.7865 10.9092 20.3204V20.1676Z",
    fill: "#F98979"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1819 30.0393V10.4482H21.8182V30.0393H18.1819Z",
    fill: "#F98979"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCents, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/cents.82a49682.svg";
export { ForwardRef as ReactComponent };